module.exports = __webpack_public_path__ + "img/syukyaku-top-ira003.ee3549ec.png";